import React, { useEffect, useState, useCallback, useRef } from "react";
import { Button, Modal, Spin, Tooltip, notification } from "antd";
// import "./matchingRecordsTable.scss";
import TableWithStaticPagination from "../../table/tableWithStaticPagination";
import { isEmpty, map, sortBy } from "lodash";
import axios from "axios";
import sessionService from "@services/session.service";
import Icon from "@assets/icon_config";
import ExtraDetailsOfUser from "../../interventionCases/detailsOfUser/detailsOfUser";
import { formatDisplayDate } from "@utils/helpers";
import "./mergeEmpiAction.scss";
import SearchRecordsOfEMPI from "./searchRecords";
import WellBeEMPIService from "@services/empiService.service";

const MergeEmpiComponent = (props: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const columnsList: any = useRef(null);
  const [selectedStep, setSelectedStep] = useState("step1");
  const [target, setTarget] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let _columns = map(props.columnsNeedToShowInTable, (item) => {
      if (item.key === "member_empi_key") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          // sorter: (a: { [x: string]: any }, b: { [x: string]: any }) => a[item.dataIndex].localeCompare(b[item.dataIndex]),
          render: (value: any, record: any) => {
            return record.isOriginalRecord ? value : <div className="ui-empi-matching-merged-records__table__file-column">{record.file_name}</div>;
          },
        };
      }
      if (item.key === "action_desc") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          render: (value: any, record: any) => {
            return (
              <div className="ui-empi-matching-merged-records__table__action-column">
                <ExtraDetailsOfUser record={record} columnListForPopUp={props.columnsNeedToShowInPopUp} />
              </div>
            );
          },
        };
      } else if (item.key === "member_dob") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          // sorter: true,
          render: (value: any) => formatDisplayDate(value, "createDateFormat", "defaultDateFormat"),
        };
      } else if (item.key === "requested_on") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          // sorter: true,
          render: (value: any) => formatDisplayDate(value, "reminderDateActualFormat", "defaultDateFormat"),
        };
      } else {
        return { ellipsis: true, title: item.tableHeaderName, dataIndex: item.dataIndex, key: item.key, render: (value: any) => value || "--" };
      }
    });

    _columns = sortBy(_columns, (item: any) => {
      return item.order;
    });

    columnsList.current = _columns;
  }, [props.columnsNeedToShowInPopUp, props.columnsNeedToShowInTable, props.payer]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchData = useCallback(async () => {
    console.log("ExpandableTable.fetchData");
    setIsModalOpen(true);
    setLoading(true);
    const _data = await axios.post(`${sessionService.getClient()?.appServiceUrl}/empi/all-empi-master-matching-records`, { empiId: props.record.member_empi_key }).then((response) => {
      return response.data.data.records.allEMPIMasterMatchingRecords;
    });
    setData(_data);
    setLoading(false);
  }, [props.record.member_empi_key]);

  const handleMergeAction = () => {
    setIsLoading(true);

    WellBeEMPIService.mergeTwoEMPIs({
      sourceId: props.record?.member_empi_key,
      targetId: target?.member_empi_key,
      action: "merge",
      isEMPIMerge: true,
    }).subscribe({
      next: (v) => {
        props.setPendingUniqueIds([...props.pendingUniqueIds, props.record?.member_empi_key]);
        notification.success({
          message: "Records are being Merged",
          description: "The Chosen records are being Merged. Once processed EMPI Master will get updated.",
          placement: "top",
          className: "greenNotification",
        });
        setIsLoading(false);
        setIsModalOpen(false);
      },
      error: (e) => {
        console.log(e);
        setIsLoading(false);
      },
    });
  };

  return (
    <>
      <Tooltip title="EMPI to EMPI Merge Action" placement={'left'}>
        <span className="action-icon" onClick={() => fetchData()}>
          <Icon name="split" />
        </span>
      </Tooltip>
      <Modal
        width={1000}
        footer={[
          <div>
            <Button size="large" onClick={() => handleCancel()}>
              Cancel
            </Button>
            {selectedStep === "step1" && (
              <Button onClick={() => setSelectedStep("step2")} size="large" type="primary">
                Next
              </Button>
            )}
            {selectedStep !== "step1" && (
              <Button size="large" type="primary" disabled={isEmpty(target)} onClick={() => handleMergeAction()}>
                Merge
              </Button>
            )}
          </div>,
        ]}
        centered
        title={`Merge Record: ${props.record.member_first_name} ${props.record.member_last_name}`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Spin spinning={isLoading}>
          <div className="ui-empi-master-merge-tab">
            <div className={selectedStep === "step1" ? "activeTab" : ""} onClick={() => setSelectedStep("step1")}>
              <div className="dot">1</div>Please review records to merge
            </div>
            <div>
              <Icon name="arrowRight" />
            </div>
            <div className={selectedStep === "step2" ? "activeTab" : ""} onClick={() => setSelectedStep("step2")}>
              <div className="dot">2</div>Search and Choose record to merge with
            </div>
          </div>
          {selectedStep === "step1" && (
            <div className="ui-empi-matching-merged-records">
              <TableWithStaticPagination
                className="ui-empi-matching-merged-records__table"
                columns={columnsList.current}
                data={[{ ...props.record, isOriginalRecord: true }, ...data]}
                loading={loading}
              />
              {/* {isEmpty(data) && !loading ? <NoDataFound className="ui-empi-matching-records__no-data-found" /> : null} */}
            </div>
          )}
          {selectedStep === "step2" && (
            <div>
              <SearchRecordsOfEMPI
                columnsNeedToShowInSearchTable={props.columnsNeedToShowInSearchTable}
                columnsNeedToShowInSearchPopUp={props.columnsNeedToShowInSearchPopUp}
                setTarget={setTarget}
                sourceEmpiId={props.record?.member_empi_key}
              />
            </div>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default MergeEmpiComponent;
